;(function() {
  angular.module('app.ui.form.ctrls').controller('ProfileModalCtrl', [
    '$scope',
    '$http',
    '$log',
    '$modalInstance',
    '$location',
    'data',
    '$translate',
    'logger',
    'sharedProperties',
    'practicesService',
    function(
      $scope,
      $http,
      $log,
      $modalInstance,
      $location,
      data,
      $translate,
      logger,
      sharedProperties,
      practicesService
    ) {
      $translate.use('en')
      $scope.nextButtonShow = data.displayNextButton
      const isModalForHistoryPracticeAreas =
          data.isModalForHistoryPracticeAreas,
        corporatePracticeId = 3,
        capMarketPracticeId = 19,
        equityCapMarketPracticeIdForCapMarket = 22,
        equityCapMarketPracticeIdForCorporate = 61

      let isEquityCapMarketAlreadyCounted = false,
        maxSelectablePracticeAreas = data.maxSelectablePracticeAreas
          ? data.maxSelectablePracticeAreas
          : 20
      //assign max PAs to be selected as per given, if not default to 20

      $scope.count = 0
      $scope.data = data.data
      $scope.showLocations = false
      $scope.showPractices = false
      $scope.showCategories = false
      $scope.showLanguages = false
      $scope.showTextArea = false
      $scope.showJurisdictions = false
      $scope.showAdditionalInfo = false
      $scope.element = data.element
      $scope.heading = ''
      $scope.CheckBox = ''
      $scope.updatedData = {
        data: $scope.data,
        element: '',
      }
      $scope.showChildLocations = false

      function isEquityCapitalPractice(practiceId) {
        return (
          practiceId === equityCapMarketPracticeIdForCapMarket ||
          practiceId === equityCapMarketPracticeIdForCorporate
        )
      }

      function isAnyEquityCapMarketSelected(practiceId) {
        if (
          isEquityCapitalPractice(practiceId) &&
          !isEquityCapMarketAlreadyCounted
        ) {
          var isEquityCapMarketSelectedForCapMarkets = isEquityCapMarketSelected(
              $scope.updatedData.data,
              capMarketPracticeId,
              equityCapMarketPracticeIdForCapMarket
            ),
            isEquityCapMarketSelectedForCorporate = isEquityCapMarketSelected(
              $scope.updatedData.data,
              corporatePracticeId,
              equityCapMarketPracticeIdForCorporate
            )

          isEquityCapMarketAlreadyCounted = true
          return (
            isEquityCapMarketSelectedForCapMarkets ||
            isEquityCapMarketSelectedForCorporate
          )
        } else {
          return false
        }
      }
      $scope.isHeadingBold = false
      if ($scope.element === 'location') {
        $scope.heading = 'modal.locations.Heading'
        $scope.subHeading = 'modal.locations.subHeading'
        $scope.showLocations = true
        $scope.isHeadingBold = true
      } else if ($scope.element === 'practice') {
        data.linearPractices.forEach(function(practice, index, array) {
          if (
            practice.isSelected &&
            !practice.hasChild &&
            !isAnyEquityCapMarketSelected(practice.practice_ID)
          ) {
            $scope.count++
          }
        })
        $scope.heading = 'modal.practiceAreas.Heading'
        if (isModalForHistoryPracticeAreas) {
          $scope.subHeading = 'modal.employmentHistory.practiceAreas.subHeading'
        } else $scope.subHeading = 'modal.practiceAreas.subHeading'

        $scope.showPractices = true
        $scope.isHeadingBold = true
        $scope.updatedData
      } else if ($scope.element === 'language') {
        $scope.updatedData.element = data.element
        if (
          data.otherLanguages !== '' ||
          data.otherLanguages !== null ||
          data.otherLanguages !== void 0
        ) {
          $scope.updatedData.otherLanguages = data.otherLanguages
        }
        $scope.heading = 'modal.languages.Heading'
        $scope.showLanguages = true
      } else if ($scope.element === 'jurisdiction') {
        $scope.updatedData.element = data.element
        if (
          data.other_Jurisdictions !== '' ||
          data.other_Jurisdictions !== null ||
          data.other_Jurisdictions !== void 0
        ) {
          $scope.updatedData.other_Jurisdictions = data.other_Jurisdictions
        }
        $scope.heading = 'modal.updateJurisdictions.Heading'
        $scope.subHeading = 'modal.updateJurisdictions.subHeading'
        $scope.showJurisdictions = true
        $scope.isHeadingBold = true
      } else if ($scope.element === 'category') {
        $scope.heading = 'modal.firmTypes.Heading'
        $scope.showCategories = true
      } else if ($scope.element === 'move') {
        $scope.heading = 'modal.moveQuestion.Heading'
        $scope.showTextArea = true
        $scope.updatedData.element = 'move'
      } else if ($scope.element === 'info') {
        $scope.heading = 'modal.moreInfoQuestion.Heading'
        $scope.showAdditionalInfo = true
        $scope.updatedData.element = 'info'
      }
      $scope.updateData = function(event, cur_box) {
        var message, value
        if ($scope.showLocations) {
          $scope.updatedData.element = $scope.element
          value = event.target.checked
          $scope.updatedData.data.forEach(function(chkbox, index, array) {
            if (chkbox.loc_ID === cur_box.loc_ID) {
              chkbox.isSelected = value
            }
          })
        } else if ($scope.showPractices) {
          $scope.updatedData.element = $scope.element
          value = event.target.checked
          $scope.countCheckbox(value, 2)
          if ($scope.count > maxSelectablePracticeAreas) {
            message =
              'You are allowed to choose a maximum of ' +
              maxSelectablePracticeAreas +
              ' practice areas.'
            logger.notify('error', message)
            event.target.checked = false
            value = false
            $scope.count = maxSelectablePracticeAreas
          } else if ($scope.count <= maxSelectablePracticeAreas) {
            if ($scope.count === maxSelectablePracticeAreas) {
              message =
                'You have reached the limit for practice area selections, please refine your expertise to only those practice areas you have actual experience in'
              logger.notify('warning', message)
            } else if (
              $scope.count < maxSelectablePracticeAreas &&
              $scope.count === 15
            ) {
              message =
                'You are approaching the limit for practice area selections'
              logger.notify('warning', message)
            }

            $scope.updatedData.data.forEach(function(chkbox, index, array) {
              if (chkbox.practice_ID === cur_box.practice_ID) {
                chkbox.isSelected = value
              }
            })
          }
        } else if ($scope.showLanguages) {
          $scope.updatedData.element = $scope.element
          value = event.target.checked
          $scope.updatedData.data.forEach(function(chkbox, index, array) {
            if (chkbox.code === cur_box.code) {
              chkbox.isSelected = value
            }
          })
        } else if ($scope.showJurisdictions) {
          $scope.updatedData.element = $scope.element
          value = event.target.checked
          $scope.updatedData.data.forEach(function(chkbox, index, array) {
            if (chkbox.id === cur_box.id) {
              chkbox.isSelected = value
            }
          })
        } else if ($scope.showCategories) {
          $scope.updatedData.element = $scope.element
          value = event.target.checked
          $scope.updatedData.data.forEach(function(chkbox, index, array) {
            if (chkbox.cat_ID === cur_box.cat_ID) {
              chkbox.isSelected = value
            }
          })
        }
      }
      $scope.displaySubPracticeAreas = function(law_area) {
        return (law_area.showSubPracticeAreas = true)
      }
      $scope.hideSubPracticeAreas = function(law_area) {
        return (law_area.showSubPracticeAreas = false)
      }
      $scope.displayChildLocations = function(region) {
        return (region.showChildLocations = true)
      }
      $scope.hideChildLocations = function(region) {
        return (region.showChildLocations = false)
      }

      function decrementCount() {
        if ($scope.count > 0) $scope.count--
      }

      function isEquityCapMarketSelected(
        practiceAreas,
        parentPracticeId,
        childPracticeId
      ) {
        var parentPractice = findPractice(practiceAreas, parentPracticeId),
          childPractice = findPractice(
            parentPractice.practices,
            childPracticeId
          )

        return childPractice.isSelected
      }

      function findPractice(listOfPractices, practiceId) {
        return _.find(listOfPractices, practice => {
          return practice.practice_ID === practiceId
        })
      }
      $scope.selectPractices = function(event, current, level) {
        let message,
          pCounter = 0,
          sCounter = 0,
          value = event.target.checked

        $scope.updatedData.element = 'practice'
        if ($scope.count >= maxSelectablePracticeAreas && value) {
          message =
            'You are allowed to choose a maximum of ' +
            maxSelectablePracticeAreas +
            ' practice areas.'
          logger.notify('error', message)
          event.target.checked = false
          return false
        } else {
          if (level === 2) {
            $scope.updatedData.data.forEach(function(law_area, index, array) {
              if (law_area.practice_ID === current.practice_ID) {
                law_area.isSelected = value
                if (law_area.practices.length > 0) {
                  law_area.practices.forEach(function(practice, index, array) {
                    if (
                      practice.sub_areas.length > 0 &&
                      (!value || $scope.count < maxSelectablePracticeAreas)
                    ) {
                      practice.isSelected = value
                      practice.sub_areas.forEach(function(sub, index, array) {
                        if (sub.isSelected !== value) {
                          if (
                            $scope.count < maxSelectablePracticeAreas &&
                            value
                          ) {
                            sub.isSelected = value
                            $scope.count++
                          } else if (!value && sub.isSelected) {
                            decrementCount()
                            sub.isSelected = value
                          }
                        }
                      })
                    } else {
                      if ($scope.count < maxSelectablePracticeAreas && value) {
                        practice.isSelected = value
                        $scope.count++
                      } else if (!value && practice.isSelected) {
                        practice.isSelected = value
                        decrementCount()
                      }
                    }
                  })
                } else {
                  if (value && $scope.count < maxSelectablePracticeAreas) {
                    law_area.isSelected = value
                    $scope.count++
                  } else if (!value) {
                    law_area.isSelected = value
                    decrementCount()
                  }
                }

                practicesService.checkForLinking(
                  $scope.updatedData.data,
                  current.practice_ID,
                  value
                )
              }
            })
          } else if (level === 1) {
            $scope.updatedData.data.forEach(function(law_area, index, array) {
              return law_area.practices.forEach(function(
                practice,
                index,
                array
              ) {
                if (practice.practice_ID === current.practice_ID) {
                  if (practice.sub_areas.length > 0) {
                    practice.isSelected = value
                    law_area.practices.forEach(function(p, i, a) {
                      if (p.isSelected) {
                        pCounter++
                      }
                    })
                    if (value) {
                      if (pCounter > 0) {
                        law_area.isSelected = value
                      }
                    } else {
                      if (pCounter <= 0) {
                        law_area.isSelected = value
                      }
                    }
                    practice.sub_areas.forEach(function(sub, index, array) {
                      if (sub.isSelected !== value) {
                        if (
                          $scope.count < maxSelectablePracticeAreas &&
                          value
                        ) {
                          sub.isSelected = value
                          $scope.count++
                        } else if (!value) {
                          if (sub.isSelected) {
                            sub.isSelected = value
                            decrementCount()
                          }
                        }
                      }
                    })
                  } else {
                    if ($scope.count < maxSelectablePracticeAreas && value) {
                      practice.isSelected = value

                      law_area.practices.forEach(function(p, i, a) {
                        if (p.isSelected) {
                          pCounter++
                        }
                      })
                      if (value) {
                        if (pCounter > 0) {
                          law_area.isSelected = value
                        }
                      } else {
                        if (pCounter <= 0) {
                          law_area.isSelected = value
                        }
                      }
                      $scope.count++
                    } else if (!value) {
                      practice.isSelected = value
                      law_area.practices.forEach(function(p, i, a) {
                        if (p.isSelected) {
                          pCounter++
                        }
                      })
                      if (value) {
                        if (pCounter > 0) {
                          law_area.isSelected = value
                        }
                      } else {
                        if (pCounter <= 0) {
                          law_area.isSelected = value
                        }
                      }
                      decrementCount()
                    }
                  }

                  practicesService.checkForLinking(
                    $scope.updatedData.data,
                    current.practice_ID,
                    value
                  )
                }
              })
            })
          } else if (level === 0) {
            $scope.updatedData.data.forEach(function(law_area, index, array) {
              law_area.practices.forEach(function(practice, index, array) {
                if (practice.sub_areas.length > 0) {
                  practice.sub_areas.forEach(function(sub, index, array) {
                    if (sub.practice_ID === current.practice_ID) {
                      sub.isSelected = value
                      practice.sub_areas.forEach(function(s, i, a) {
                        if (s.isSelected) {
                          sCounter++
                        }
                      })
                      if (value) {
                        if (sCounter > 0) {
                          law_area.isSelected = value
                          practice.isSelected = value
                        }
                      } else {
                        if (sCounter <= 0) {
                          practice.isSelected = value
                          law_area.practices.forEach(function(p, i, a) {
                            if (p.isSelected) {
                              pCounter++
                            }
                          })
                          if (value) {
                            if (pCounter > 0) {
                              law_area.isSelected = value
                            }
                          } else {
                            if (pCounter <= 0) {
                              law_area.isSelected = value
                            }
                          }
                        }
                      }
                      if (value) {
                        $scope.count++
                      } else {
                        decrementCount()
                      }

                      practicesService.checkForLinking(
                        $scope.updatedData.data,
                        current.practice_ID,
                        value
                      )
                    }
                  })
                }
              })
            })
          }

          if ($scope.count === maxSelectablePracticeAreas) {
            message =
              'You have reached the limit for practice area selections, please refine your expertise to only those practice areas you have actual experience in.'
            logger.notify('warning', message)
          } else if (
            $scope.count < maxSelectablePracticeAreas &&
            $scope.count === 15
          ) {
            message =
              'You are approaching the limit for practice area selections'
            logger.notify('warning', message)
          }
        }
      }

      $scope.selectLocation = function(event, current, level) {
        var pCounter, sCounter, value
        pCounter = 0
        sCounter = 0
        $scope.updatedData.element = 'location'
        value = event.target.checked
        if (level === 2) {
          $scope.updatedData.data.forEach(function(region, index, array) {
            if (region.loc_ID === current.loc_ID) {
              region.isSelected = value
              if (region.locations.length > 0) {
                region.locations.forEach(function(location, index, array) {
                  location.isSelected = value
                  location.sub_areas.forEach(function(sub, index, array) {
                    if (sub.isSelected !== value) {
                      if (value) {
                        sub.isSelected = value
                        $scope.count++
                      } else if (!value) {
                        sub.isSelected = value
                        decrementCount()
                      }
                    }
                  })
                  if (value) {
                    location.isSelected = value
                    return $scope.count++
                  } else if (!value && location.isSelected) {
                    location.isSelected = value
                    return decrementCount()
                  }
                })
              } else {
                if (value) {
                  region.isSelected = value
                  return $scope.count++
                } else if (!value) {
                  region.isSelected = value
                  return decrementCount()
                }
              }
            }
          })
          return
        } else if (level === 1) {
          $scope.updatedData.data.forEach(function(region, index, array) {
            return region.locations.forEach(function(location, index, array) {
              if (location.loc_ID === current.loc_ID) {
                if (location.sub_areas.length > 0) {
                  location.isSelected = value
                  region.locations.forEach(function(p, i, a) {
                    if (p.isSelected) {
                      pCounter++
                    }
                  })
                  if (value) {
                    if (pCounter > 0) {
                      region.isSelected = value
                    }
                  } else {
                    if (pCounter <= 0) {
                      region.isSelected = value
                    }
                  }
                  location.sub_areas.forEach(function(sub, index, array) {
                    if (sub.isSelected !== value) {
                      if (value) {
                        sub.isSelected = value
                        $scope.count++
                      } else if (!value) {
                        if (sub.isSelected) {
                          sub.isSelected = value
                          decrementCount()
                        }
                      }
                    }
                  })
                } else {
                  if (value) {
                    location.isSelected = value
                    region.locations.forEach(function(p, i, a) {
                      if (p.isSelected) {
                        pCounter++
                      }
                    })
                    if (value) {
                      if (pCounter > 0) {
                        region.isSelected = value
                      }
                    } else {
                      if (pCounter <= 0) {
                        region.isSelected = value
                      }
                    }
                    $scope.count++
                  } else if (!value) {
                    location.isSelected = value
                    region.locations.forEach(function(p, i, a) {
                      if (p.isSelected) {
                        pCounter++
                      }
                    })
                    if (value) {
                      if (pCounter > 0) {
                        region.isSelected = value
                      }
                    } else {
                      if (pCounter <= 0) {
                        region.isSelected = value
                      }
                    }
                    decrementCount()
                  }
                }
              }
            })
          })
          return
        } else if (level === 0) {
          $scope.updatedData.data.forEach(function(region, index, array) {
            region.locations.forEach(function(location, index, array) {
              if (location.sub_areas.length > 0) {
                location.sub_areas.forEach(function(sub, index, array) {
                  if (sub.loc_ID === current.loc_ID) {
                    sub.isSelected = value
                    location.sub_areas.forEach(function(s, i, a) {
                      if (s.isSelected) {
                        sCounter++
                      }
                    })
                    if (value) {
                      if (sCounter > 0) {
                        region.isSelected = value
                        location.isSelected = value
                      }
                    } else {
                      if (sCounter <= 0) {
                        location.isSelected = value
                        region.locations.forEach(function(p, i, a) {
                          if (p.isSelected) {
                            pCounter++
                          }
                        })
                        if (value) {
                          if (pCounter > 0) {
                            region.isSelected = value
                          }
                        } else {
                          if (pCounter <= 0) {
                            region.isSelected = value
                          }
                        }
                      }
                    }
                    if (value) {
                      $scope.count++
                    } else {
                      decrementCount()
                    }
                  }
                })
              }
            })
          })
        }
      }
      $scope.countCheckbox = function(value, level) {
        if (value) {
          $scope.count++
        } else if (!value) {
          decrementCount()
        }
      }
      $scope.selectAll = function(event) {
        let mainCheckBox, message, value
        mainCheckBox = event.target.attributes.data.value
        value = event.target.checked
        if (value) {
          if ($scope.count >= maxSelectablePracticeAreas) {
            message =
              'You are allowed to choose a maximum of ' +
              maxSelectablePracticeAreas +
              ' practice areas.'
            logger.notify('error', message)
            event.target.checked = false
            return false
          } else if ($scope.count < maxSelectablePracticeAreas) {
            $scope.data.forEach(function(chkbox, index, array) {
              if (
                chkbox.lawArea_ID === parseInt(mainCheckBox) &&
                !chkbox.isSelected &&
                $scope.count < maxSelectablePracticeAreas
              ) {
                $scope.countCheckbox(value, 1)
                chkbox.isSelected = value
              }
            })
          }
        } else {
          $scope.data.forEach(function(chkbox, index, array) {
            if (
              chkbox.lawArea_ID === parseInt(mainCheckBox) &&
              chkbox.isSelected
            ) {
              $scope.countCheckbox(value, 1)
              chkbox.isSelected = value
            }
          })
        }
      }
      $scope.save = function() {
        if (
          $scope.updatedData.element === 'practice' ||
          isModalForHistoryPracticeAreas
        ) {
          if ($scope.count <= maxSelectablePracticeAreas) {
            $scope.updatedData.linearPractices = []
            $scope.updatedData.data.forEach(function(law_area, index, array) {
              $scope.updatedData.linearPractices.push(law_area)
              law_area.practices.forEach(function(practice, index, array) {
                $scope.updatedData.linearPractices.push(practice)
                practice.sub_areas.forEach(function(sub, index, array) {
                  return $scope.updatedData.linearPractices.push(sub)
                })
              })
            })
            var categorizedPractices = _.countBy(
              $scope.updatedData.linearPractices,
              practice => {
                return practice.isSelected ? 'selected' : 'unselected'
              }
            )

            if (
              isModalForHistoryPracticeAreas &&
              !sharedProperties.isAdminSession() &&
              !categorizedPractices.selected
            ) {
              logger.notify(
                'info',
                'It is mandatory for a work experience to have practice areas'
              )
              return
            }

            $modalInstance.close($scope.updatedData)
          } else {
            $modalInstance.dismiss('cancel')
          }
        } else {
          if ($scope.updatedData.element === 'jurisdiction') {
            if ($scope.updatedData.data.find(data => data.isSelected === true))
              $modalInstance.close($scope.updatedData)
            else
              logger.notify(
                'warning',
                'This is a required field, you have to choose at least one jurisdiction.'
              )
          } else $modalInstance.close($scope.updatedData)
        }
      }
      $scope.cancel = function() {
        $modalInstance.dismiss('cancel')
      }
    },
  ])
})()



// WEBPACK FOOTER //
// ./scripts/shared/ProfileModalCtrl.js